import { render, staticRenderFns } from "./RestaurantsList.vue?vue&type=template&id=15ae2fa2"
import script from "./RestaurantsList.vue?vue&type=script&lang=js"
export * from "./RestaurantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports